var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { PureComponent } from 'react';
import * as CLS from './cls';

var GalleryArrow = function (_PureComponent) {
    _inherits(GalleryArrow, _PureComponent);

    function GalleryArrow() {
        _classCallCheck(this, GalleryArrow);

        return _possibleConstructorReturn(this, (GalleryArrow.__proto__ || Object.getPrototypeOf(GalleryArrow)).apply(this, arguments));
    }

    _createClass(GalleryArrow, [{
        key: 'render',
        value: function render() {
            var props = this.props;
            var _props = this.props,
                className = _props.className,
                _props$fill = _props.fill,
                fill = _props$fill === undefined ? '' : _props$fill;


            return React.createElement(
                'span',
                {
                    className: CLS.iconClass.mix(className)(),
                    onClick: props.onClick
                },
                React.createElement(
                    'svg',
                    {
                        fill: fill,
                        width: '24',
                        height: '24'
                    },
                    React.createElement(
                        'g',
                        { fillRule: 'evenodd' },
                        React.createElement('path', { d: 'M4 13h12.17l-5.59 5.59L12 20l8-8-8-8-1.41 1.41L16.17 11H4z' }),
                        React.createElement('path', { fillOpacity: '.01', d: 'M24 24H0V0h24z' })
                    )
                ),
                props.children
            );
        }
    }]);

    return GalleryArrow;
}(PureComponent);

export default GalleryArrow;